module.exports = __webpack_public_path__ + "img/btn_colorectal_on.87d7f5dc.svg";